import type { FloorSpaceCatalog } from "@/models/floor-space-catalog";
import { schema as catalogSchema } from "@/models/floor-space-catalog";
import { schema as collection } from "@/models/passage-collection";
import { Api } from "@/utils";

const baseUrl = "v1/floor-space-catalogs";

/**
 * Fetches FloorSpaceCatalog records for a floor space and parses them with Zod.
 *
 * @param {number} floorSpaceId - The floor space ID to fetch catalogs for.
 * @returns {Promise<FloorSpaceCatalog[]>} The parsed FloorSpaceCatalog records.
 */
export const getByFloorSpaceId = async (
    floorSpaceId: number,
): Promise<FloorSpaceCatalog[]> => {
    const response = await Api.get(`${baseUrl}/floor-space-id/${floorSpaceId}`);
    const { result } = collection(catalogSchema).parse(response);
    return result;
};
